import { Check, X } from "lucide-react";

export const Section = ({ title, hint, children, testId }) => (
  <section data-testid={testId} className="space-y-4 rounded-2xl border bg-card p-5 sm:p-6">
    <div>
      <h3 className="text-lg font-bold">{title}</h3>
      {hint && <p className="mt-1 text-sm text-muted-foreground">{hint}</p>}
    </div>
    {children}
  </section>
);

export const YesNo = ({ value, onChange, yes = "Yes", no = "No", testId, danger = "no" }) => {
  const btn = (v, label, Icon) => {
    const active = value === v;
    const bad = (danger === "no" && !v) || (danger === "yes" && v);
    const activeCls = bad ? "border-red-500 bg-red-500/15 text-red-300" : "border-emerald-500 bg-emerald-500/15 text-emerald-300";
    return (
      <button type="button" data-testid={`${testId}-${v ? "yes" : "no"}`} onClick={() => onChange(v)}
        className={`flex min-h-[52px] flex-1 items-center justify-center gap-2 rounded-xl border-2 px-4 text-sm font-bold transition-colors ${active ? activeCls : "border-border text-muted-foreground hover:border-zinc-500"}`}>
        <Icon className="h-4 w-4" /> {label}
      </button>
    );
  };
  return <div className="flex gap-3">{btn(true, yes, Check)}{btn(false, no, X)}</div>;
};

export const ScorePicker = ({ value, onChange, testId }) => (
  <div className="grid grid-cols-2 gap-3">
    <button type="button" data-testid={`${testId}-1`} onClick={() => onChange(1)}
      className={`min-h-[56px] rounded-xl border-2 px-3 py-2 text-left text-sm font-bold transition-colors ${value === 1 ? "border-emerald-500 bg-emerald-500/15 text-emerald-300" : "border-border text-muted-foreground hover:border-zinc-500"}`}>
      <span className="font-mono text-lg">1</span> <span className="block text-xs font-semibold">Advanced standard</span>
    </button>
    <button type="button" data-testid={`${testId}-2`} onClick={() => onChange(2)}
      className={`min-h-[56px] rounded-xl border-2 px-3 py-2 text-left text-sm font-bold transition-colors ${value === 2 ? "border-red-500 bg-red-500/15 text-red-300" : "border-border text-muted-foreground hover:border-zinc-500"}`}>
      <span className="font-mono text-lg">2</span> <span className="block text-xs font-semibold">Not advanced standard</span>
    </button>
  </div>
);

export function previewOutcome(f) {
  if (f.eyesight_pass === false) return "cancelled";
  const failing = f.unsafe_behaviour || Object.values(f.competencies).some((c) => c.score === 2);
  if (!failing) return "pass";
  return f.refer_to_trustees ? "referred" : "unsuccessful";
}
